import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private toastrService: ToastrService,
  ) { }

  public success(message: string, title = '') {
    this.toastrService.success(message, title, {
      timeOut: 3000,
      closeButton: true,
      easing: 'ease-in',
    });
  }

  public info(message: string, title = '') {
    this.toastrService.info(message, title, {
      timeOut: 3000,
      // extendedTimeOut: 0,
      // timeOut: 0,
      closeButton: false,
      easing: 'ease-in',
    });
  }

  public error(message: string, title = '') {
    this.toastrService.error(message, title, {
      timeOut: 3000,
      easing: 'ease-in',
    });
  }
  
  public warning(message: string, title = '') {
    this.toastrService.warning(message, title);
  }
}
